import Icon from 'vue-awesome/components/Icon'

Icon.register({
  person_pin_circle_rounded: {
    paths: [
      {
        d: 'M12 2C8.14 2 5 5.14 5 9c0 4.17 4.42 9.92 6.24 12.11.4.48 1.13.48 1.53 0C14.58 18.92 19 13.17 19 9c0-3.86-3.14-7-7-7zm0 2a2 2 0 11.001 4.001A2 2 0 0112 4zm0 10c-1.67 0-3.14-.85-4-2.15.02-1.32 2.67-2.05 4-2.05s3.98.73 4 2.05A4.783 4.783 0 0112 14z'
      }
    ],
    width: '24',
    height: '24'
  }
})
